const utf8Bom = '\uFEFF';

function createAndClickAnchor(href: string, download: string) {
  const link = document.createElement('a');
  link.href = href;
  link.download = download;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export function downloadBlob(blob: Blob, name: string) {
  if (!blob || !(blob instanceof Blob)) {
    // eslint-disable-next-line no-console
    console.error('downloadBlob: Invalid blob provided', blob);
    return;
  }
  const url = URL.createObjectURL(blob);
  createAndClickAnchor(url, name);
}

export function downloadTextFile(contents: string, name: string) {
  const encodedContents = encodeURIComponent(`${utf8Bom}${contents}`);
  const url = `data:text/plain;charset=utf-8,${encodedContents}`;
  createAndClickAnchor(url, name);
}
